import request from 'utils/request'

// 获取通知邮箱
export const getEmails = () => request().get('bpm/notify/config/details')

// 保存邮箱
export const saveEmails = data => request().post('bpm/notify/config', data)

// 获取担保归档人员
export const getGuarantee = data => request().get('bpm/notify/secureRole', data)
